import actions from "./actions";

const initState = {
  organizationsStatistics: [],
  loading: false,
};

export default function reducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.GET_ORGANIZATIONS_STATISTICS_SUCCESS:
      return {
        ...state,
        organizationsStatistics: action.organizationsStatistics,
      };
    case actions.GET_ORGANIZATIONS_STATISTICS_BY_DATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_ORGANIZATIONS_STATISTICS_BY_DATE_SUCCESS:
      const updatedOrganizationsStatistics = state.organizationsStatistics.map(
        (org) => {
          const organizationDataByDates =
            action.organizationsByDatesStatistics.find(
              (orgByDates) => orgByDates.organizationId === org.organizationId
            );

          return {
            ...org,
            visitsByDates: organizationDataByDates
              ? organizationDataByDates.visits
              : null,
            ordersByDates: organizationDataByDates
              ? organizationDataByDates.orders
              : null,
            myPosPaymentsByDates: organizationDataByDates
              ? organizationDataByDates.myPosPayments
              : null,
          };
        }
      );

      return {
        ...state,
        organizationsStatistics: updatedOrganizationsStatistics,
        loading: false,
      };

    default:
      return state;
  }
}
